import {createAction} from '../../base/fsa';

export const setUserAction = createAction(resolve => (username: string, password: string) => resolve({username, password}));

export const clearUserAction = createAction();
